export const DATE_FORMAT = 'YYYY-MM-DD'
export const FRIENDLY_DATE_FORMAT = 'DD.MM.YYYY'

export const warningSign = '\u26A0'
